import _ from "lodash";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../..";
import NavHeader from "../../Components/NavHeader";
import { isEmail } from "../../Functions/isEmail";
import { QUESTIONS } from "../../Utils/Questions";
import { addUser } from "./Helpers";
import Question from "./Question";
import "./styles.css";

function Reflection(props) {
  let navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [HE, setHE] = useState([]);
  const [HRNATURE, setHRNATURE] = useState([]);
  const [HEA, setHEA] = useState([]);
  const [HHS, setHHS] = useState([]);
  const [HUEE, setHUEE] = useState([]);
  const [HUHC, setHUHC] = useState([]);
  const [HUHR, setHUHR] = useState([]);
  const [HY, setHY] = useState([]);

  const [topHM, setTopHM] = useState([]);
  const [topEV, setTopEV] = useState([]);
  const [topSV, setTopSV] = useState([]);
  const [topValues, setTopValues] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const questionRef = useRef();

  const renderQuestion = () => {
    //console.log(currentIndex, "Current Index");
    switch (currentIndex) {
      case 0:
        return renderNewSection();
      case 1:
        return (
          <Question
            data={QUESTIONS[1]}
            options={QUESTIONS[1].options}
            selectedValues={HY}
            onChange={(res) => {
              setHY(res);
            }}
          />
        );
      case 2:
        return renderNewSection();
      case 3:
        return (
          <Question
            data={QUESTIONS[3]}
            options={QUESTIONS[3].options}
            selectedValues={HUEE}
            onChange={(res) => {
              setHUEE(res);
            }}
          />
        );
      case 4:
        return (
          <Question
            data={QUESTIONS[4]}
            options={QUESTIONS[4].options}
            selectedValues={HUHR}
            onChange={(res) => setHUHR(res)}
          />
        );
      case 5:
        return (
          <Question
            data={QUESTIONS[5]}
            options={QUESTIONS[5].options}
            selectedValues={HUHC}
            onChange={(res) => setHUHC(res)}
          />
        );
      case 6:
        return renderNewSection();
      case 7:
        return (
          <Question
            data={QUESTIONS[7]}
            options={QUESTIONS[7].options}
            selectedValues={HE}
            onChange={(res) => setHE(res)}
          />
        );
      case 8:
        return (
          <Question
            data={QUESTIONS[8]}
            options={QUESTIONS[8].options}
            selectedValues={HRNATURE}
            onChange={(res) => setHRNATURE(res)}
          />
        );
      case 9:
        return (
          <Question
            data={QUESTIONS[9]}
            options={QUESTIONS[9].options}
            selectedValues={HHS}
            onChange={(res) => setHHS(res)}
          />
        );
      case 10:
        return (
          <Question
            data={QUESTIONS[10]}
            options={QUESTIONS[10].options}
            selectedValues={HEA}
            onChange={(res) => setHEA(res)}
          />
        );
      case 11:
        return renderNewSection();
      case 12:
        //const topEnvironmental = _.concat(HE, HRNATURE, HHS, HEA);
        //console.log(topEnvironmental, "COOOOOLIE");
        return (
          <Question
            data={QUESTIONS[12]}
            options={HY}
            selectedValues={topHM}
            onChange={(responses) => setTopHM(responses)}
          />
        );
      case 13:
        const topSocial = _.concat(HUEE, HUHR, HUHC);
        return (
          <Question
            data={QUESTIONS[13]}
            options={topSocial}
            selectedValues={topSV}
            onChange={(responses) => setTopSV(responses)}
          />
        );
      case 14:
        const topEnvironmental = _.concat(HE, HRNATURE, HHS, HEA);
        return (
          <Question
            data={QUESTIONS[14]}
            options={topEnvironmental}
            selectedValues={topEV}
            onChange={(responses) => setTopEV(responses)}
          />
        );
      case 15:
        return (
          <Question
            data={QUESTIONS[15]}
            options={[]}
            selectedValues={[]}
            onNameChange={(e) => setName(e.target.value)}
            onEmailChange={(e) => setEmail(e.target.value)}
            inputName={name}
            inputEmail={email}
          />
        );
      default:
        return null;
    }
  };

  const renderNewSection = () => {
    return (
      <Question
        data={QUESTIONS[currentIndex]}
        options={[]}
        selectedValues={[]}
      />
    );
  };

  const isComplete = () => {
    const currentLimit = QUESTIONS[currentIndex].choiceLimit;
    switch (currentIndex) {
      case 0:
        return true;
      case 1:
        return HY.length === currentLimit;
      //return HE.length === currentLimit;
      //return HRNATURE.length === currentLimit;
      case 2:
        return true;
      case 3:
        return HUEE.length === currentLimit;
      case 4:
        return HUHR.length === currentLimit;
      case 5:
        return HUHC.length === currentLimit;
      case 6:
        return true;
      case 7:
        return HE.length === currentLimit;
      case 8:
        return HRNATURE.length === currentLimit;
      case 9:
        return HHS.length === currentLimit;
      case 10:
        return HEA.length === currentLimit;
      case 11:
        return true;
      case 12:
        return topHM.length === currentLimit;
      case 13:
        return topSV.length === currentLimit;
      case 14:
        return topEV.length === currentLimit;
      case 15:
        if (name.length >= 1 && isEmail(email)) {
          return true;
        } else {
          return null;
        }
      default:
        return true;
    }
  };

  const handleNext = () => {
    questionRef.current.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setCurrentIndex((prev) => prev + 1);
  };

  const handleBack = () => {
    questionRef.current.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setCurrentIndex((prev) => prev - 1);
  };

  const handleSubmit = () => {
    const arr = _.concat(topHM, topEV, topSV);
    const valuesArray = arr.map((item, index) => {
      return item.value;
    });
    var params = new URLSearchParams({
      name: name,
      values: valuesArray,
    }).toString();
    const new_url = new URL(`http://localhost:3000/esr/results/?${params}`);
    //console.log(new_url, "This is the complete data");
    //alert("Youre done");
    /* console.log(
      params,
      valuesArray,
      new_url.pathname,
      "TOP VALUES ARRAY & PATHNAME!"
    ); */
    addUser({ name, email, topValues: valuesArray });
    navigate(`${new_url.pathname + new_url.search}`);
  };

  return (
    <div id="reflection">
      <NavHeader />
      <div ref={questionRef} className="questionContainer">
        <div className="progressContainer">
          {QUESTIONS[currentIndex].type === "newSection" || 'form' ? null : (
            <p className="progress">
              Question # {QUESTIONS[currentIndex].number}
            </p>
          )}
          <p className="currentQuestion">{QUESTIONS[currentIndex].question}</p>
          <p className="subHeading">{QUESTIONS[currentIndex].subheading}</p>
          <p className="questionInstructions">
            {QUESTIONS[currentIndex].instructions}
          </p>
        </div>
        {renderQuestion()}
      </div>
      <div className="controlsContainer">
        {/* <Progress color={'#81984B'} value={currentIndex} max={QUESTIONS.length} /> */}
        <div className="buttonContainer">
          {currentIndex !== 0 ? (
            <button
              className="backButton"
              marginRight={"1em"}
              onClick={handleBack}
            >
              Back
            </button>
          ) : null}
          {currentIndex < QUESTIONS.length - 1 ? (
            <button
              disabled={!isComplete()}
              className={isComplete() ? "nextButton" : "disabledButton"}
              onClick={handleNext}
            >
              Next
            </button>
          ) : (
            <button
              disabled={!isComplete()}
              className={isComplete() ? "nextButton" : "disabledButton"}
              onClick={handleSubmit}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Reflection;
